button:
  about: About
  back: Return
  home: Home Page
  reset: Reset
  search: Search
  operation: Operation
  edit: Edit
  save: Save
  cancel: Cancel
  confirm: Confirm
not-found: Page not found
commodity-management: SKU List
order-management: Order List
store: Account
storeInfo: Account List
integrationSet: Intergration Setting
orde-sync-policy: Order Sync Policy
postal-service-update-policy: Postal Service Update Policy
vendor: Vendor
postal-service-required: Please complete all necessary information indicated by an asterisk "*"!
atLeastOne : Please maintain at least one linnworks postal service.

synchronization-platform-sku: Sync Platform SKU
synchronization-platform-order: Sync Orders
synchronization-platform-order-placeholder: Input Platform OrderID
tracking-number-status: Fulfilment Status
lw-order-status: Order Status
select-lw-order-status: Please select Order Status
oc-outbound-order-status: OC Outbound Order Status
select-oc-bound-order-status: Please select the OC outbound order status
platform-order-number: Platform Order No
ocOutboundOrderStatus:
  draft: Draft
  submitted: Submitted
  accepted: Accepted
  cancelled: Cancelled
  createPickingTask: Create Picking Task
  picked: Picked
  exception: Exception
  packed: Packed
  outbound: Outbound
  inDelivery: In-Delivery
  delivered: Delivered
  undeliverableReturn: Undeliverable Return
  failed: Failed
  buyerReturn: Buyer Return
trackingNumberStatusLabels:
  all: All
  waiting: Pending Fulfill
  already: Completed
  failed: Abnormal
  canceled: Cancelled
form-order-numbers-placeholder: Enter up to 20 order number, one order number per line
form-sku-placeholder: Enter up to 20 SKU number, one SKU number per line
statusLabels:
  all: All
  waiting: Pending Push
  already: Success
  abnormal: Abnormal
  failed: Fail
syncStatusLabels:
  all: All
  success: Success
  fail: Fail
  init: Pending Sync
  ing: Sync in progress
status: Status
inventory-sync-status: 'Inventory Sync Status'
batch-push-to-oc: Batch Push To OC
inventory-sync-strategy: Inventory Sync Policy
batch-sync-inventory: Batch Synchronize Inventory
authStatus: Authorization Status
authLabels:
  all: All
  active: Active
  inActive: InActive
authTable:
  platform: Platform
  storeName: Shop Name
  ocId: OCID
  authStatus: Authorization Status
  authTime: Authorization Time
bulkOrder: Fulfill
syncPolicy: Sync Policy
orderList:
  orderId: Platform Order No
  paymentStatus: Payment Status
  logisticsStatus: Fulfillment Status
  trackingNumberStatus: Order Status
  buyerCountry: Destination Country
  orderSkuAndQuantity: Order SKU * Quantity
  totalPrice: Order Amount
  payTime: Payment Time
  packageCode: OC Order ID
  packageStatus: OC Order Status
  warehouseCore: Warehouse
  logisticsProvider: Carrier
  thirdPartyNo: Shipping Service
  trackingNumber: TrackingNO
  salesTime: Create Time
  cancelOrder: Cancel Order
  orders: Fulfill
  shipmentStatus: Shipment Sync Platform Status
editAddress:
  buyerAddress1: Address1
  buyerAddress2: Address2
  buyerCity: City
  buyerName: Full Name
  buyerCompany: Company Name
  buyerEmail: Email
  buyerMobile: Phone
  buyerCountry: Country / Region
  buyerState: State
  houseNumber: House Number
  buyerPostalCode: Zip Code
  orderNotes: Remarks
paymentStatusValue:
  paymentStatus0: Unpaid
  paymentStatus1: Paid
  paymentStatus2: Partial Payment
  paymentStatus3: Refunded
  paymentStatus4: Partial Refund
  paymentStatus5: Payment Voided
  paymentStatus6: Payment Failed
  paymentStatus7: Paid(Pending)
  paymentStatus8: Re Order
logisticStatusValue:
  logisticStatus0: Checking
  logisticStatus1: Pending Fulfill
  logisticStatus2: Completed
  logisticStatus3: Partial Shipment
  logisticStatus4: Signed
  logisticStatus5: Partial Receipt
  logisticStatus6: Cancelled
  logisticStatus7: Partial Cancellation
addressDialog:
  title: Edit Shipping Address
  buyerNamePlaceholder: Recipient name field cannot be blank
  buyerAddress1Placeholder: Receiving address 1 field cannot be blank
  buyerCountryCodePlaceholder: Please select the Country
deliverySkuAndQuantity: SKU * Quantity
shipmentStatusValue:
  shipmentStatus0: To be Sync
  shipmentStatus1: Success
  shipmentStatus2: Synchronizing
  shipmentStatus3: Fail
responseMessage:
  selectOrder: Please select an order
  selectGoods: Please select a product
  operateSuccess: Operation succeeded
  setSyncOrderSuccess: In processing, please be patient
  operateError: Operation failed, please try again
  setOrderSuccess: Operation order placed successfully
  setOrderFailed: Operation order failed
  enterOrderNo: Please enter the order number
  pushSuccess: Push succeeded
  pushFailed: Push failed
  changeInventoryOrInputValue: Please select a warehouse or enter a fixed quantity value
  exceptionSuccess: Exception handling succeeded
  saveSuccess: Saved successfully
cancelOrder: Cancel Order
orderNo: Order Number
cancelOrderDialog:
  content: OC order is being cancelled, please operate with caution.
  title: Prompt for canceling OC order
  success: Order cancelled successfully
  error: Order cancellation failed
commodityManagement:
  pushStatus: Push Status
  syncStatus: Inventory Sync Status
  syncTime: Latest Sync Inventory Time
  push: Push
  syncInventory: Synchronize Inventory
  rePush: Push again
  exceptionHandle: Exception Handling
  productTitle: Product Name
  platformInventory: Platform Inventory
  ocInventory: OC Inventory
  price: Price
syncInventoryDialog:
  title: Inventory Sync Policy
  platformInventory: Platform Inventory
  addRule: Add Rule
  deleteBtn: Delete
  deleteTip: Are you sure to delete ?
  prompting: Prompting
  location: Location
  efWh: eF Warehouse
  required: Required
  reconfirm: You haven't set up Inventory Sync Policy, inventory can not synchronize from OC
pushToOcDialog:
  title: Prompt for pushing SKU to OC
  content: The selected SKU will be push to OC, please confirm before operation.
  confirmTxt: Confirm
syncStockDialog:
  title: Sync Inventory Tips
  content: The selected SKU Inventory will be resynchronized according to the rules. Please confirm before operating.
  confirmTxt: Confirm Sync
exceptionDialog:
  title: Exception Handling Tips
  content: SKU cannot be pushed to OC again. If you need any modification on the seller SKUID, you need to get contact with Orange Connex customer service. Please ensure that you have to complete the order from the old seller SKUID.
  confirmTxt: Got it
strategyDialog:
  placeholder: Please select a warehouse or enter a fixed value
  title: Inventory Sync Policy
warningMes:
  maxSku: You can only enter up to 20 SKU
  maxOrder: You can only enter up to 20 order numbers
  noSelect: No data selected
  positiveInteger: Fixed value must be a positive integer
  needNum: Fixed value must be numeric
  enterSku: Please enter SKU
  enterToken: Please enter Token
  isOrders: The selected order has been placed, please do not repeat
syncSkuResponse:
  title: Inventory synchronization succeeded
  content1: The task of sync SKU has been completed. Refresh the page to review.
  content2: 'Total number of synchronizations:'
  content3: 'Total success:'
  content4: 'Total number of failures:'
  failed: Failed SKU
  allFailed: Sync of SKU failed
syncOrdersResponse:
  title: Batch order completion
  content1: Batch order has been completed. Refresh the page to review.
  content2: 'Total number of sync:'
  content3: 'Total Success:'
  content4: 'Total number of failures:'
  failed: 'Failed Order:'
  allFailed: Batch order failed
error:
  systemError: System error. Please contact your administrator.
order-source: Order Source
order-source—all: All
order-source—others: Others
platform-order-id: Platform Order ID
ebay-order-id: eBay Order ID
oc-order-id: OC Order ID
table-ebay-order-id: 'eBay OrderID:'
autofulfill-setting: Autofulfill Settings
platform-order-switch-tip: Platforms Orders, mapping with OC warehouses and services will be autofulfiled.
ebay-order-switch-tip: Only eBay will be autofulfiled.
other-order-switch-tip: Other source orders will be autofulfiled.
autofulfill-switch-tip: will be autofulfiled.
warehouse-mapping: Warehouse Mapping
warehouse-mapping-text: Platform Orders with Distribution Center info, mapping to OC Fulfillment Center
oc-fulfillment-center: OC Fulfillment Center
platform-distribution-center: Platform Distribution Center
shipping-mapping: Shipping Service Mapping
shipping-mapping-text: Platform Shipping Carrier/Shipping Class, mapping to OC shipping service
oc-shipping-service: OC Shipping Service
platform-carrier: Platform Carrier/Shipping Class
carrier-name: CarrierName-ShippingClass
add: ADD
autofulfill-cancel: CANCEL
autofulfill-save: SAVE
autofulfill-open: ON
autofulfill-close: OFF
autofulfill-example: 'Example: UPS-Standard'
repeat-tip: platform shipping method with the same code has been mapped
authorize: Authorize
reAuthorize: Re-authorize
getToken: Authorize to get Token
recycleBin: Order Recycle Bin
deleteOrder: Delete Order
reduction: Order Recover
delContent: Are you sure you want to delete the selected order? The order can be recovered  from the 【Order Recycle Bin】 after deletion.
configTitle1: Add OC Identifier to an order:：
configTitle2: '*OC will add this Identifier to Linnworks order as OC fulfilled this order'
locationSetTitle: Location to Process Order
locationSetTitleTips: Choose one Linnworks location to process your orders from
locationSetLabel: Location

